// Library Imports
import React, { Component } from "react";

export default class LoadingFallBack extends Component {
  render() {
    console.log('Loading FallBack Called');
    return (
      <section>
        <div id="loader">
          <div className="loading" style={{ zIndex: 9999 }}>
            <div className="dot"></div>
            <div className="dot1"></div>
            <div className="dot2"></div>
            <div className="dot3"></div>
            <div className="dot4"></div>
          </div>
        </div>
      </section>
    );
  }
}
